module.exports = __webpack_public_path__ + "img/icon-8.0e7245af.png";